import { useQuery } from "@tanstack/react-query";
import { api } from "../utils/apiClient";
import type { AirlineOption } from "../types";

const fetchAirlines = async (): Promise<AirlineOption[]> => {
  const res = await api.get("/api/v1/airlines");
  return res.json();
};

export const useAirlinesQuery = () => {
  return useQuery({
    queryKey: ["/api/v1/airlines"],
    queryFn: fetchAirlines,
    staleTime: 5 * 60 * 1000,
  });
};
